"use client";
import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import HeroSection from "../../components/HeroSection/HeroSection";
import ProblemSection from "../../components/Problemsection/Problemsection";
import OnePlatformSection from "../../components/Oneplatformsection/Oneplatformsection";
import ClinicalWorkflowsSection from "../../components/Clinicalworkflowssection/Clinicalworkflowssection";
import SimpleFromDayOneSection from "../../components/SimpleFromDayOneSection/SimpleFromDayOneSection";
import DifferentCategorySection from "../../components/DifferentCategorySection/DifferentCategorySection";

import BuiltForManySection from "../../components/BuiltForManySection/BuiltForManySection";
import FooterCTASection from "../../components/FooterCTASection/FooterCTASection";
import "./LandingPage.css";
import VoiceBot from "../../components/VoiceBot/VoiceBot";

export default function LandingPage() {
  return (
    <div className="landing-page">
      <Navbar />

      <div id="home">
        <HeroSection />
      </div>

      <div id="problem">
        <ProblemSection />
      </div>

      <div id="platform">
        <OnePlatformSection />
      </div>

      <div id="workflows">
        <ClinicalWorkflowsSection />
      </div>

      <div id="simple">
        <SimpleFromDayOneSection />
      </div>

      <div id="category">
        <DifferentCategorySection />
      </div>

      <div id="built-for">
        <BuiltForManySection />
      </div>
      <FooterCTASection />
            <VoiceBot />

    </div>
  );
}